module.exports = __webpack_public_path__ + "static/img/pendant.5a5dba30.png";